export default "__VITE_ASSET__C2Gkz$YH__"